import { config } from '../config';
import { getHeaders } from './getHeaders';

export const getRoofer = (token: string) =>
  fetch(`${config.apiBaseUrl}/api/v1/roofer/me`, {
    headers: getHeaders(token),
  });
